export default "__VITE_ASSET__wR7$0BTT__"